import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    message: String,
    messageType: String
  }

  connect() {
    Alert.show(this.messageValue, this.messageTypeValue)
  }
}
